/**
 * F-013 — Drag distance → launch power conversion.
 *
 * Eases a 0..1 normalized drag distance into a launch impulse magnitude.
 * Settings (F-022) will adjust the multiplier; defaults aimed at a
 * "snappy but feathered" feel where small drags barely tap and full
 * drag clears half the playfield in ~1.5s.
 */

const DEFAULT_MIN_IMPULSE = 1;
const DEFAULT_MAX_IMPULSE = 18;
const DEFAULT_EASING_EXPONENT = 1.4;

export interface PowerCurveOptions {
  min?: number;
  max?: number;
  /** >1 makes the low-end gentler, the high-end snappier. */
  exponent?: number;
}

export function computeLaunchImpulse(
  power01: number,
  options: PowerCurveOptions = {},
): number {
  const min = options.min ?? DEFAULT_MIN_IMPULSE;
  const max = options.max ?? DEFAULT_MAX_IMPULSE;
  const exp = options.exponent ?? DEFAULT_EASING_EXPONENT;
  if (max <= min) throw new Error("computeLaunchImpulse: max must be > min");
  const clamped = Math.max(0, Math.min(1, power01));
  const eased = Math.pow(clamped, exp);
  return min + (max - min) * eased;
}

export const __testing = {
  DEFAULT_MIN_IMPULSE,
  DEFAULT_MAX_IMPULSE,
  DEFAULT_EASING_EXPONENT,
};
